var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-locale-provider',{attrs:{"locale":_vm.locale}},[_c('div',{class:{lightColor:_vm.$store.state.bgLight},attrs:{"id":"app"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }